import { Reducer } from 'redux'
import Cookies from 'universal-cookie'
import _ from 'lodash'
import * as actions from './actions'
import { PaymentTemplate, PaymentTemplateValidationResult, PaymentTemplateValidationParameters } from './types'

export const cookies = new Cookies()

export type PaymentTemplateState = Readonly<{
  paymentTemplates: Record<string, PaymentTemplate>
  isValidating: boolean
  isSaving: boolean
  validationResult: PaymentTemplateValidationResult | null
  selectedPaymentTemplate: PaymentTemplateValidationParameters | null
}>

export const initState: PaymentTemplateState = {
  paymentTemplates: {},
  isValidating: false,
  isSaving: false,
  validationResult: null,
  selectedPaymentTemplate: null
}

// reducer
export const paymentTemplateReducer: Reducer<PaymentTemplateState, actions.PaymentTemplateActions> = (
  state = initState,
  action
) => {
  switch (action.type) {
    case actions.FETCH_PAYMENT_TEMPLATES_SUCCESS:
      return {
        ...state,
        paymentTemplates: { ..._.keyBy(action.payload, 'id') }
      }
    default:
      return state
  }
}
